import { render, staticRenderFns } from "./menu-bar-destroy.vue?vue&type=template&id=40325fb0&"
import script from "./menu-bar-destroy.vue?vue&type=script&lang=js&"
export * from "./menu-bar-destroy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports